let seq = 0;
export const uid = () => `u${Date.now().toString(36)}${(++seq).toString(36)}`;
